import { Inject } from 'inversify-props'
import { VendaServiceAdapter } from './adapter'
import { Fornecedor, ModalidadeDeFrete, UsuarioBase, Venda } from '@/models'
export class EditarUmaVendaUseCase {
	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	async executar(id: string, venda: EdicaoDeUmaVenda): Promise<Venda>  {

		if ((!venda.informacoesDeTransporte?.especie) ||
				(!venda .informacoesDeTransporte?.volume)) {
			if ((venda.informacoesDeTransporte?.especie) ||
							(venda.informacoesDeTransporte?.volume)) {
				throw new Error('Não informado todos os dados do frete');	
			}
		}

		return await this.vendaService.update(id, {
			informacoesDeTransporte: {
				...venda.informacoesDeTransporte,
				especie: venda.informacoesDeTransporte?.especie || null,
				volume: venda.informacoesDeTransporte?.volume || null,
				pesoLiquido: venda.informacoesDeTransporte?.pesoLiquido || null,
				pesoBruto: venda.informacoesDeTransporte?.pesoBruto || null,
				fornecedor: venda.informacoesDeTransporte?.fornecedor || null,
			},
			volumes: venda.volumes,
		})
	}

	async patchVendedor(idVenda: string, vendedor: UsuarioBase): Promise<Venda> {
		return await this.vendaService.patchVendedor(idVenda, vendedor)
	}

	async patchRepresentante(idVenda: string, representante: UsuarioBase): Promise<Venda> {
		return await this.vendaService.patchRepresentante(idVenda, representante)
	}

	async enviarEmail(vendaId: string, email: string): Promise<void> {
		await this.vendaService.enviarEmail(vendaId, email)
	}

}

export interface EdicaoDeUmaVenda {
	informacoesDeTransporte?: EdicaoDeInformacaoDeTransporte
	volumes?: string[]
}

export interface EdicaoDeInformacaoDeTransporte {
	modalidadeDeFrete: ModalidadeDeFrete
	volume: number | null | ''
	especie: string | null
	pesoLiquido: number | null
	pesoBruto: number | null | ''
	fornecedor: Fornecedor | null
	valorFrete: number | null | ''
}
